import React, { Component } from "react";
import { actions } from "../../store/medals";
import { connect } from "react-redux";
import styles from "./Header.module.css";
import starPath from "../../images/star.svg";

class Header extends Component {
  openMedalsModal = () => this.props.openModal();

  render() {
    return (
      <header className={styles.headerContainer}>
        <a href="http://suvorovmuseum.ru/" target="blank">
          <div className={styles.headerText}>
            <p>ГОСУДАРСТВЕННЫЙ МЕМОРИАЛЬНЫЙ</p>
            <p>
              <strong>МУЗЕЙ А.В. СУВОРОВА</strong>
            </p>
          </div>
        </a>
        <div className={styles.countWrapper}>
          <p className="text">{this.props.medals.length}</p>
          <div
            className={[styles.starWrapper, "blueBG"].join(" ")}
            onClick={this.openMedalsModal}>
            <img
              src={starPath}
              alt="Нажмите 'читать далее', что бы получить медаль"></img>
          </div>
        </div>
      </header>
    );
  }
}

const mapStateToProps = (state) => ({
  medals: state.medals,
});

const mapActionsToProps = {
  addMedals: actions.addMedals,
  openModal: actions.openModal,
};

export default connect(mapStateToProps, mapActionsToProps)(Header);
